import axios from 'axios';

const PRODUCTION_API = 'https://api.iskenderun.bel.tr';

const resolveBaseUrl = () => {
  const raw = process.env.REACT_APP_API_URL || '';
  if (!raw) {
    console.warn('[api] REACT_APP_API_URL boş, production URL kullanılıyor:', PRODUCTION_API);
    return PRODUCTION_API;
  }
  const trimmed = raw.endsWith('/api') ? raw.slice(0, -4) : raw;
  // env geçerliyse olduğu gibi kullan
  try {
    new URL(trimmed);
  } catch { /* geçersiz URL ise fallback */ }
  return trimmed;
};

const BASE_URL = resolveBaseUrl();
console.info('[api] BASE_URL:', BASE_URL);

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

// Attach the JWT token to every request when it exists.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Normalize API responses and centralize auth failures.
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      console.error('API error:', {
        endpoint: error.config?.url,
        status: error.response.status,
        data: error.response.data
      });

      if (error.response.status === 401) {
        const headers = error.response.headers || {};
        const headerValue = headers['x-session-revoked'] ?? headers['X-Session-Revoked'];
        const isRevoked = (headerValue ?? '').toString().toLowerCase() === 'true';
        const message = isRevoked
          ? 'Oturumunuz sonlandırıldı. Lütfen tekrar giriş yapın.'
          : 'Oturum süresi doldu. Lütfen tekrar giriş yapın.';

        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(new Error(message));
      }
    } else if (error.request) {
      console.error('Network error:', {
        endpoint: error.config?.url,
        message: error.message
      });
    } else {
      console.error('Request error:', error.message);
    }

    return Promise.reject(error);
  }
);

export { BASE_URL };
export default api;
